import type {ProductDetails} from '../models/ProductDetails';
import ApiClient from '../../API/api';
import type {ProductDeals} from '../models/ProductDeals';
import HttpRequestError from '../../API/models/HttpRequestError';

const GET_PRODUCT_ENDPOINT = 'product/code/:productCode';
const GET_DISCOUNTS_ENDPOINT = 'product/sales';
const FAVORITE_ENDPOINT = 'account/favorites';

const parseGetProduct = (response) => {
  if (response.status > 300) {
    throw new HttpRequestError('Failed to get product', JSON.stringify(response));
  }
  return response;
};

export default class ProductService {

  static getProduct = (productCode): Promise<ProductDetails> => {
    return ApiClient.performRequest(
      GET_PRODUCT_ENDPOINT,
      { pathParams: { productCode } }
    ).then(parseGetProduct);
  };

  static getProductDeals = (productCode): Promise<ProductDeals> => {
    return ApiClient.performRequest(
      GET_DISCOUNTS_ENDPOINT,
      {
        queryParams: { productCode: productCode }
      }
    );
  };

  static changeFavorite = (productCode, favorite): Promise<void> => {
    const method = favorite ? 'DELETE' : 'POST';
    return ApiClient.performRequest(
      FAVORITE_ENDPOINT,
      { method, queryParams: { cod_articulo: productCode } }
    );
  };

  static getFavorites = (): Promise<ProductDetails> => {
    return ApiClient.performRequest(FAVORITE_ENDPOINT);
  };
}
